export interface ArticleSummary {
  slug: string;
  title: string;
  description: string;
  readTime: string;
  category: string;
}

export const featuredArticle: ArticleSummary = {
  slug: 'usfans-spreadsheet-guide',
  title: 'What Is the USFans Spreadsheet? A Complete Beginner Guide',
  description: 'Learn what the USFans Spreadsheet is, how it is organized, and how to use it for product research, QC checks, shipping estimates and safer buying.',
  readTime: '8 min read',
  category: 'USFans Spreadsheet',
};

export const pillarArticles: ArticleSummary[] = [
  {
    slug: 'usfans-review',
    title: 'USFans Review: Features, Pros, Cons and What to Consider',
    description: 'An honest overview of the platform, its workflow, advantages, limitations and the things to think about before you start.',
    readTime: '12 min read',
    category: 'Review',
  },
  {
    slug: 'usfans-legit',
    title: 'Is USFans Legit? Safety, Trust and How to Verify',
    description: 'How to tell a real resource apart from a fake one, plus practical steps to verify links, sellers and payments.',
    readTime: '11 min read',
    category: 'Safety',
  },
  {
    slug: 'usfans-shipping-cost',
    title: 'USFans Shipping Cost Guide: What Really Affects the Price',
    description: 'How parcel weight, method and destination work together to shape your final shipping cost.',
    readTime: '10 min read',
    category: 'Shipping',
  },
  {
    slug: 'usfans-shipping-methods',
    title: 'USFans Shipping Methods Compared: Which One to Choose',
    description: 'A side-by-side look at common shipping methods, their trade-offs and which situations they suit best.',
    readTime: '10 min read',
    category: 'Shipping',
  },
  {
    slug: 'usfans-warehouse',
    title: 'USFans Warehouse Guide: Storage, Inspection and Consolidation',
    description: 'Understand how storage, inspection, consolidation and parcel preparation fit together before checkout.',
    readTime: '12 min read',
    category: 'Warehouse',
  },
  {
    slug: 'usfans-qc',
    title: 'USFans QC Explained: How to Read Quality Control Photos',
    description: 'Learn what QC actually means and how to read quality control photos and checklists before you decide.',
    readTime: '9 min read',
    category: 'QC',
  },
  {
    slug: 'usfans-coupon',
    title: 'USFans Coupon & Discount Code Guide',
    description: 'Where coupons usually come from, how to check them and how to avoid fake or expired codes.',
    readTime: '8 min read',
    category: 'Coupon',
  },
  {
    slug: 'usfans-sellers',
    title: 'USFans Sellers Guide: How to Compare and Choose Wisely',
    description: 'A practical framework for comparing sellers, reading their information and avoiding common mistakes.',
    readTime: '11 min read',
    category: 'Sellers',
  },
  {
    slug: 'usfans-product-research',
    title: 'USFans Product Research Guide: Find the Right Item',
    description: 'A step-by-step method to narrow categories, compare items and confirm details before you buy.',
    readTime: '10 min read',
    category: 'Products',
  },
  {
    slug: 'usfans-buying-guide',
    title: 'USFans Complete Buying Guide: From Research to Checkout',
    description: 'The end-to-end journey from first search to final checkout, with checklists and safety reminders.',
    readTime: '13 min read',
    category: 'Buying Guide',
  },
];

export const articleSummaries: ArticleSummary[] = [featuredArticle, ...pillarArticles];

export function getSummary(slug: string): ArticleSummary | undefined {
  return articleSummaries.find((a) => a.slug === slug);
}